import React from "react";
import OwlCarousel from "react-owl-carousel";
import { motion } from "framer-motion";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./clients.scss";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const options = {
  margin: window.innerWidth > 600 ? 20 : 10,
  loop: true,
  autoplay: window.innerWidth > 600 ? true : false,
  autoplayTimeout: window.innerWidth > 600 ? 2000 : null,
  autoplayHoverPause: window.innerWidth > 600 ? true : false,
  smartSpeed: 600,
  autoplaySpeed: 600,
  nav: true,
  dots: false,
  navText: [
    "<img src='/assets/left.svg'/>",
    "<img src='/assets/right.svg'/>",
  ],
  responsive: {
    0: { items: 1 },
    300: { items: 1.1 },
    400: { items: 1.1 },
    600: { items: 1.1 },
    1000: { items: 2.5 },
    1300: { items: 3.5 },
    1700: { items: 4.5 },
  },
};


const testimonials = [
  {
    img: "/assets/user.svg",
    name: "Transparent Pricing",
    title: "🔍",
    quote:
      "Clear, predictable pricing with no hidden fees.",
  },
  {
    img: "/assets/user2.svg",
    name: "100% In-House Execution",
    title: "🏢",
    quote:
      "No outsourcing complete control and quality delivery.",
  },
  {
    img: "/assets/user3.svg",
    name: "Cross-Domain Expertise",
    title: "🧠",
    quote:
      "Integrated strategies across IT, cybersecurity, and automation.",
  },
  {
    img: "/assets/user4.svg",
    name: "Certified Prossionals",
    title: "🛡️",
    quote:
      "Professionals certified in Microsoft, Cisco, ISO, Infosec and more..",
  },






  {
    img: "/assets/user4.svg",
    name: "Trusted Across Industries",
    title: "🏆",
    quote:
      "Proven success in healthcare, finance, education, and beyond.",
  }, {
    img: "/assets/user4.svg",
    name: "Data-Driven Execution",
    title: "📊",
    quote:
      "Our strategies are measurable, with full visibility into outcomes and KPIs.",
  },
  {
    img: "/assets/user4.svg",
    name: "Scalable Solutions",
    title: "🧩",
    quote:
      "Solutions designed to grow with your business no vendor lock-in.",
  },
  {
    img: "/assets/user4.svg",
    name: "Global Reach, Local Expertise",
    title: "🌍",
    quote:
      "We support global clients while staying aligned with local compliance and operations.",
  },
  {
    img: "/assets/user4.svg",
    name: "Innovation-First Culture",
    title: "💡",
    quote:
      "We embrace automation, AI, and emerging tech to future-proof your organization.",
  },
  {
    img: "/assets/user4.svg",
    name: "Quick Support Options",
    title: "🕒",
    quote:
      "Rapid-response helpdesk with flexible support plans available anytime, anywhere to resolve issues fast.",
  },
  {
    img: "/assets/user4.svg",
    name: "Unified Microsoft 365 & SharePoint",
    title: "📁",
    quote:
      "Deep expertise in governance, collaboration, and automation using Microsoft ecosystem.",
  },

  {
    img: "/assets/user4.svg",
    name: "End-to-End Ownership",
    title: "🔄",
    quote:
      "We plan, build, deploy, and support all with zero handoffs.",
  },


];

const Clients = () => (
  <section className="slider_Div mynewseccc chooosediv" id="whychooseus">
    <h5 className="headingusss">Why Choose us</h5>
    <div className="cardshead newcatdddsd">
      <OwlCarousel className="owl-theme" {...options}>
        {testimonials.map((t, i) => (
          <motion.div
            key={i}
            className="cards neversuse"
            variants={cardVariants}
            initial="visible"
            whileInView="visible"
            whileHover={{
              scale: 1.05,
              transition: { duration: 0.3, ease: "easeOut" },
            }}
            viewport={{ once: false, amount: 0.4 }}
          >
            {/* <img src={t.img} alt={t.title} className="imggguseer" /> */}
            <h6>{t.title}</h6>
            <h2>{t.name}</h2>

            <p>“{t.quote}”</p>
          </motion.div>
        ))}
      </OwlCarousel>
    </div>
  </section>
);

export default Clients;
